import React from 'react';
import { Link, Popover, Stack, Typography } from '@mui/material';
import styled from 'styled-components';
import { ReactComponent as Logo } from '../vendor/logoOli.svg';
import OliLogo from '../vendor/oli.png';

const Brand = styled(Logo)`
  fill: ${(props) => props.theme.palette.primary.main};
  width: 24px;
  height: 24px;
`;

const ContactComponent = ({ anchorEl, handleClose }) => {
  return (
    <Popover
      PaperProps={{
        variant: 'outlined',
        elevation: 0,
        sx: { p: 5, width: 'min(90%, 320px)' },
      }}
      id="Kontakt-popover"
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
    >
      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={2} mb={10}>
          <Brand />
          <Link
            href="https://www.my-oli.com"
            target="_blank"
            rel="noopener noreferrer"
            color="text.secondary"
          >
            www.my-oli.com
          </Link>
        </Stack>
        <img src={OliLogo} alt="" width={100} />
      </Stack>
      <Typography variant="h4" component="h2" fontWeight={600} sx={{ my: 4 }}>
        ContactComponent
      </Typography>
      <Typography>
        This website uses cookies to improve your experience while you navigate
        through the website. Out of these, the cookies that are categorized as
        necessary are stored obn your browser as they are essential for the
        working of basic functionalities of the web...
      </Typography>
    </Popover>
  );
};

export default ContactComponent;
